import React from 'react';
import { CropperModal } from './CropperModal/CropperModal';
import CustomUploadButton from './CustomUploadButton/CustomUploadButton';
import ImageFileUpload from './ImageFileUpload/ImageFileUpload';
import { ImageUploadProvider } from './ImageUploadContext/ImageUploadContext';

const ImageUpload = ({
  children,
  onCancelCropper,
  onCompleteCrop,
  onFileInputClick,
  onError,
  aspectRatio,
  circleCrop,
  title = '',
}: {
  children: React.ReactElement;
  onCancelCropper?: () => void;
  onCompleteCrop: (croppedImage: Blob) => void;
  onFileInputClick?: () => void;
  onError?: (error: ErrorEvent) => any;
  aspectRatio?: string;
  circleCrop?: boolean;
  title?: string;
}) => (
  <ImageUploadProvider
    onCompleteCrop={onCompleteCrop}
    onCancelCropper={onCancelCropper}
    onFileInputClick={onFileInputClick}
    onError={onError}
  >
    <CropperModal aspectRatio={aspectRatio} circleCrop={circleCrop} title={title} />
    <ImageFileUpload />
    <CustomUploadButton children={children} />
  </ImageUploadProvider>
);

export default ImageUpload;
